var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEventSection = function SvgEventSection(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    transform: "translate(-42.000000, -224.000000)",
    fill: "#AAAAAA",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(32.000000, 214.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(10.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.75,1.7 L16.15,1.7 C16.619442,1.7 17,2.08055796 17,2.55 L17,16.15 C17,16.619442 16.619442,17 16.15,17 L0.85,17 C0.380557963,17 0,16.619442 0,16.15 L0,2.55 C0,2.08055796 0.380557963,1.7 0.85,1.7 L4.25,1.7 L4.25,0 L5.95,0 L5.95,1.7 L11.05,1.7 L11.05,0 L12.75,0 L12.75,1.7 Z M1.7,6.8 L1.7,15.3 L15.3,15.3 L15.3,6.8 L1.7,6.8 Z M3.4,10.2 L7.65,10.2 L7.65,13.6 L3.4,13.6 L3.4,10.2 Z",
    id: "Shape"
  })))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEventSection);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/eventSection.f6bc3c7303316b1fa826a2bd82346980.svg";